import axios from 'axios';
import { store } from '../app/store';

// Create axios instance with base configuration
export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true, // Always send cookies
});
axios.defaults.withCredentials = true;

// Request interceptor - Attach auth token + CSRF token
axiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const csrfToken = state.csrf.token;

    // Attach the JWT so authenticated endpoints (e.g. /update-user-data) receive it.
    // Harmless on public endpoints — the backend simply ignores it when not required.
    const token = localStorage.getItem('viart_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // Add CSRF token to all non-GET requests
    if (csrfToken && config.method !== 'get') {
      config.headers['X-CSRF-Token'] = csrfToken;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle CSRF errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle CSRF token errors
    if (error.response?.status === 403 && error.response?.data?.message?.includes('CSRF')) {
      console.error('CSRF token invalid or expired. Please refresh the page.');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;